<template>
  <div class="search-result-component">
    <div class="container">
      <div class="row mt-5">
        <div class="col-lg-12">
            <div class="no-result" v-show="results !== undefined && results.length === 0">
                No result found
            </div>
          <div
            class="search-results mt-5"
            v-for="(result, index) in results"
            :key="index"
          >
            <div class="product-name">{{ result.name }}</div>
            <div class="product-url">
              <a :href="`/products/${result.categorySlug}`">{{
                productUrl(result.categorySlug)
              }}</a>
            </div>
            <div class="product-description">
              {{ result.description | limitDescription }}...
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-lg-12 text-center"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchResult",
  props: {
    results: Array,
  },
  methods: {
    productUrl(categorySlug) {
      return `${window.location.protocol}://${window.location.host}/products/${categorySlug}`;
    },
  },
  filters: {
    limitDescription(description) {
      return description.substring(0, 100);
    },
  },
};
</script>

<style lang="sass" scoped>
.search-results
    font-family: "Gotham"
    .product-name
        font-size: 1.5rem

    .product-url
        text-transform: uppercase
        font-size: 0.75rem

    .product-description
        font-size: 1rem

    a, a:visited, a:hover
        text-decoration: none
        color: $dutche-primary-brown
</style>
